import m from "mithril";
import { AuthLoginResponse } from "~/types";

export const postVerifyCode = (code: string, rememberMe: boolean): Promise<AuthLoginResponse> => {
  return m.request({
    method: "POST",
    url: "/auth/verifytotp",
    body: { code, rememberMe },
  });
};
